// ✅ Positive Number Validator
export const validatePositiveNumber = async (_: any, value: string) => {
  if (!value) {
    return Promise.resolve();
  }

  // ✅ Step 1: basic positive number check (allows decimals)
  const basicNumberRegex = /^\d+(\.\d+)?$/;
  if (!basicNumberRegex.test(value)) {
    return Promise.reject(new Error('Input must be a valid positive number'));
  }

  // ✅ Step 2: check for up to two decimal places only
  const twoDecimalRegex = /^\d+(\.\d{1,2})?$/;
  if (!twoDecimalRegex.test(value)) {
    return Promise.reject(new Error('Max 2 digits after decimal'));
  }

  // ✅ Step 3: numeric checks
  const numericValue = Number(value);

  if (numericValue === 0) {
    return Promise.reject(new Error('Input must be greater than zero'));
  }

  if (numericValue < 0) {
    return Promise.reject(new Error('Input must be positive'));
  }

  return Promise.resolve();
};
